module.exports = __webpack_public_path__ + "img/Document.4a1e2b1f.svg";